<template>
	<el-row>
		<el-col :span="12">
			<el-form label-position="left" class="demo-table-expand">
				<el-form-item label="产品名称">
					<span v-text="product.name"></span>
				</el-form-item>
				<el-form-item label="检测批次">
					<span v-text="batchInfo.roll_code"></span>
				</el-form-item>
				<el-form-item label="检测米数">
					<span v-text="batchInfo.total_len / 1000 + '米'"></span>
				</el-form-item>
				<el-form-item label="检测大张数">
					<span v-text="realBatchInfo.insp_big_sheet"></span>
				</el-form-item>
				<el-form-item label="大张废品率">
					<span>{{ realBatchInfo.bad_big_rate | ScapeRate }}%</span>
				</el-form-item>
				<el-form-item label="缺陷个数">
					<span v-text="batchInfo.total_def_count"></span>
				</el-form-item>
			</el-form>
		</el-col>
		<el-col :span="12">
			<el-form label-position="left" class="demo-table-expand">
				<el-form-item label="检测时间">
					<span v-text="begin_time_str"></span>
				</el-form-item>
				<el-form-item label="质检员">
					<span v-text="workerName"></span>
				</el-form-item>
				<el-form-item label="检测小张数">
					<span v-text="realBatchInfo.insp_small_sheet"></span>
				</el-form-item>
				<el-form-item label="小张废品率">
					<span>{{ realBatchInfo.bad_small_rate | ScapeRate }}%</span>
				</el-form-item>
				<el-form-item label="筛选员">
					<span v-text="filterOperatorName"></span>
				</el-form-item>
			</el-form>
		</el-col>
	</el-row>
</template>

<script>
	import { productRequest } from '@/network/requests/product'
	import { realBatchInfoRequest } from '@/network/requests/realBatchInfo'
	import { formatDate } from '@/util/datetime'
	import { getFactoryUsers } from '@/network/api/user'
	import { getDBName } from '@/network/config'

	export default {
		props: {
			id: {
				type: String,
			},
			batchInfo: {
				type: Object,
			},
		},
		computed: {
			productId() {
				if (this.batchInfo) {
					return this.batchInfo.product_id
				}

				return ''
			},
		},
		data() {
			return {
				/**
				 * 产品信息。
				 */
				product: {},
				/**
				 *
				 */
				realBatchInfo: {
					bad_small_rate: 0,
					bad_big_rate: 0,
					insp_small_sheet: 0,
					insp_big_sheet: 0,
				},
				/**
				 * 质检员。
				 */
				workerName: '',
				/***
				 * 筛查员。
				 */
				filterOperatorName: '',
				/**
				 * 当前数据库名称
				 */
				dbName: getDBName(),
				/**
				 * 质检开始时间。
				 */
				begin_time_str: '',
			}
		},
		filters: {
			ScapeRate(val) {
				if (val == null || val == undefined || val < 0) {
					return '0'
				} else {
					return val.toFixed(2)
				}
			},
		},
		watch: {
			/**
			 * 监听批次数据。
			 */
			batchInfo: {
				async handler(val) {
					console.log('批次信息', val)
					await this.getRealBatchInfo()

					//获取用户信息。
					await this.getUserInfoAsync()
					//检测开始时间。
					this.begin_time_str = formatDate(val.begin_time)
				},
				deep: true,
			},
			/**
			 * 监听产品ID，查询产品信息。
			 */
			async productId(val) {
				if (!val) return

				try {
					var product = (await productRequest.getDocumentById(val)).data
					this.product = product

					console.log('this.product', this.product)
				} catch (error) {
					console.error(error.message)
				}
			},
		},
		methods: {
			/**
			 * 获取用户信息。
			 */
			async getUserInfoAsync() {
				//获取所有工厂用户。
				var factoryUsersResponse = await getFactoryUsers(this.dbName)
				if (factoryUsersResponse.success) {
					var users = factoryUsersResponse.result

					if (users) {
						var user1 = users.find(t => t.id == this.batchInfo.filter_operator_id)
						if (user1) {
							this.filterOperatorName = user1.realname
							console.log('operate', this.filterOperatorName, user1)
						} else {
							this.filterOperatorName = '无'
							console.log('operate为无', user1)
						}

						var user2 = users.find(t => t.id == this.batchInfo.worker_id)
						if (user2) {
							this.workerName = user2.realname
							console.log('workname', this.workerName, user2)
						} else {
							this.workerName = '无'
						}
					}

					console.log('workers', this.workerUsers)
				}
			},
			/**
			 *
			 */
			async getRealBatchInfo() {
				var realBatchInfos = await realBatchInfoRequest.queryAll({ roll_id: this.batchInfo._id.$oid })

				if (realBatchInfos.length == 0) {
					console.error('无法获取批次筛查记录')
					return
				}

				var realBatchInfo = realBatchInfos[0]

				//总小张数,总坏品小张数,总检测大张数,总检测大张废品数
				var { insp_small_sheet, bad_small_sheet, insp_big_sheet, bad_big_sheet } = realBatchInfo

				//小张废品率。
				var bad_small_rate = (bad_small_sheet / insp_small_sheet).toFixed(4) * 100
				//大张废品率。
				var bad_big_rate = (bad_big_sheet / insp_big_sheet).toFixed(4) * 100

				this.realBatchInfo = {
					...realBatchInfo,
					bad_small_rate,
					bad_big_rate,
				}

				console.log('this.realBatchInfo', this.realBatchInfo)
			},
		},
	}
</script>

<style></style>
